export default __webpack_public_path__ + "static/media/designernews.8c9fd0ec.svg";